export interface Faq {
  q: string
  a: string[]
  list?: string[]
  afterList?: string
}

export const faqs: Faq[] = [
  {
    q: 'How do I receive Dog Grooming Instructor Ready after purchasing?',
    a: ['You receive digital access to the complete material after your purchase is completed.'],
  },
  {
    q: 'Is this an app?',
    a: [
      'No.',
      'Dog Grooming Instructor Ready is a digital teaching system that you can access from compatible devices and use as a reference during your classes.',
    ],
  },
  {
    q: 'Is this a visual product or mostly text?',
    a: [
      'The main 6-volume system is designed as 100% visual teaching material, using diagrams, sequences, styling maps, comparisons, technique breakdowns and practical reference pages.',
      'The professional bonus guides contain more detailed written reference material.',
    ],
  },
  {
    q: 'Does the package include videos?',
    a: [
      'No.',
      'The system is based on professional digital teaching material and does not include video lessons.',
    ],
  },
  {
    q: 'Is the material in English?',
    a: ['Yes.', 'The complete system is provided in English.'],
  },
  {
    q: 'Can I edit the material?',
    a: [
      'No.',
      'The material is delivered as finished digital resources and is not provided as editable source files.',
    ],
  },
  {
    q: 'Is it only for complete beginners?',
    a: [
      'No.',
      'The system can support instructors working with beginner, developing and more experienced grooming students.',
    ],
  },
  {
    q: 'Is the material only about dogs?',
    a: [
      'Yes.',
      'Dog Grooming Instructor Ready is exclusively focused on canine grooming. It does not include cats or other animal species.',
    ],
  },
]
